// TODO: add to lib folder
export const closeModalButton = (label, callback) => ({
  label,
  onClick: () => {
    callback()
  }
})
